import React from "react";
import { VideoAutoPlay } from "../Product/Call";

const ScaleUpPlanCard = () => {
  const features = [
    "200 business contacts",
    "Call Forwarding To Mobile",
    "1gb Cloud Storage",
    "Mobile & Web App Access",
    "Mobile & Web App Access",
    "Call Ratings & Agent Performance Tracking",
  ];

  return (
    <section className="start-smart-pay">
      <h1 className="start-smart-pay__title">
        Pay Smart. <span>Pay As You</span> Go. Stay Connected Without the{" "}
        <span>Extra Costs</span>
      </h1>
      <p className="start-smart-pay__subtitle">
        Pay only for what you use, when you need it. Nxatel grows with your
        business.
      </p>
      <div className="start-smart-pay__container">
        <div className="start-smart-pay__video">
          <div className="start-smart-pay__video-box">
            <VideoAutoPlay />
          </div>
        </div>
        <div className="start-smart-pay__content">
          <div className="plan-card">
            <div className="plan-card__details">
              <h4 className="plan-card__title">Scale Up Plan</h4>
              <p className="plan-card__price">R199.00</p>
              <p className="plan-card__subtitle">Per month</p>
              <p className="plan-card__info">
                <strong>Call Minutes :</strong> 350 Minutes
                <br />
                <strong>SMS :</strong> 50 Business SMS
              </p>
              <a href="/signup" className="plan-card__button">
                Try For Free
              </a>
            </div>

            <ul className="plan-card__features">
              {features.map((feature, index) => (
                <li key={index} className="plan-card__feature">
                  <img
                    src="./../assets/images/StartSmart/checkcircle.svg"
                    alt="check"
                    className="plan-card__icon"
                  />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScaleUpPlanCard;
